import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";

import React from "react";


//TODO: This should be a dynamic registry, not a static one, I'd prefer a different approach to this
type ScopeRegistry = Record<string, string>;
export const SCOPE_ROUTE_REGISTRY: ScopeRegistry = {
  "/dashboard": "dashboard",
  "/volatility-analysis": "volatility-analysis",
  "/COT-analysis": "COT-analysis",
  "/COT-portfolio": "COT-portfolio",
  "/correlation": "correlation",
  "/irr-analysis": "irr-analysis",
  "/roll-agenda": "roll-agenda",
};

function ProtectedRoutes() {
  const location = useLocation();
  const { email, isLoggedIn, scopes } = useAppSelector((state) => state.auth);
  const { isEmailVerified } = useAppSelector(
    (state) => state.auth.emailVerification,
  );

  const _authorized = email && isLoggedIn && isEmailVerified;
  //TODO: This will have edge cases if paths get more complex subpaths that share keywords.
  // This is frontend controlled, so it's already insecure, should redesign permission flow to be more robust.
  const requiredScopePath = Object.keys(SCOPE_ROUTE_REGISTRY).find(key => location.pathname.includes(key));
  const requiredScope = requiredScopePath ? SCOPE_ROUTE_REGISTRY[requiredScopePath] : null;

  console.log("requiredScope", requiredScope);

  if (!_authorized) {
    return <Navigate to="/manage-account" replace />;
  }

  if (requiredScope && !scopes.includes(requiredScope)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoutes;
